var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:`cv-side-nav-items ${_vm.carbonPrefix}--side-nav__items`,on:{"mousedown":_vm.onMousedown}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }